module.exports = __webpack_public_path__ + "static/media/checked-partial-gray.f424966d.svg";